<template>
  <!-- Toggle root: clicking anywhere flips the bound `model`; `className` prop merges in caller classes; dims and blocks the cursor when `disabled` -->
  <div class="inline-flex items-center new-toggle" :class="[clsx(className), disabled ? 'cursor-no-drop opacity-50' : 'cursor-pointer']" @click="newToggle">
    <!-- <div
        :class="clsx({
          'bg-[var(--color-brand-secondary)] new-toggle-active': model,
          'bg-[var(--color-toggle-bg)]': !model
        })"
        class="relative w-11 h-6 after:start-[2px]  peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[color:var(--color-brand-secondary)] rounded-full peer border-[color:var(--color-border)] after:content-[''] after:absolute after:top-[2px] after:bg-[var(--color-inverse-01)] after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
  </div> -->
  <!-- <div
        :class="clsx({
          'bg-[#34C759] new-toggle-active': model,
          'bg-[var(--color-toggle-bg)]': !model
        })"
        class="relative w-11 h-6 after:start-[2px]  peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[color:var(--color-brand-secondary)] rounded-full peer border-[color:var(--color-border)] after:content-[''] after:absolute after:top-[2px] after:bg-[var(--color-inverse-01)] after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
  </div> -->
  <!-- Active track/knob: background color switches based on `model`'s truthiness; the knob slides via the `.new-toggle-active` CSS class (see <style>) -->
  <div
        :class="clsx({
          'bg-[var(--color-quick-link-icon-bg)] new-toggle-active': model,
          'bg-[var(--color-toggle-bg)]': !model
        })"
        class="relative w-11 h-6 after:start-[2px]  peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[color:var(--color-brand-secondary)] rounded-full peer border-[color:var(--color-border)] after:content-[''] after:absolute after:top-[2px] after:bg-[#fff] after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
  </div>
</template>

<script setup>
import clsx from 'clsx'
/** Two-way boolean binding (`v-model`) representing the toggle's on/off state. */
const model = defineModel()

/**
 * @prop {String|Array|Object} className - Extra class value(s) merged onto the root element via `clsx`.
 * @prop {Boolean} disabled - When true, blocks toggling and applies a dimmed/no-drop cursor style.
 */
const props = defineProps({
  className: { type: [String, Array, Object], default: '' },
  disabled: { type: Boolean, default: false },
})
/** Flips `model` when the toggle is clicked, unless the component is disabled. */
function newToggle() {
  if (props.disabled) return
  model.value = !model.value
}
</script>

<style scoped lang="scss">
.new-toggle{
  &-active{
    &:after{
      transform: translateX(100%);
    }
  }
}
</style>
